
CheckoutV2.Payment.OnAccount = function(checkout, payment, extra, isReview) {
	var onaccount = this;

	this.label = 'On Account';
	this.$wrap = false;
    this.reviewSelector = '.';
    if (isReview) 
      this.reviewSelector += 'review-';

	var getContainer = function() {
		return $(onaccount.reviewSelector + 'payment-method-onaccount-container');
	}
	
	this.init = function() {
		onaccount.getContainer = getContainer;
		onaccount.$wrap = $($.parseHTML(Jemplate.process('includes/partials/payment/onAccount.html')));
	};

    this.buildReview = function() {
        var card = onaccount;
        var data = {
                    method: 'onaccount',
                    method_name: card.label,
                    payment_amount: payment.getMethodAmt( card ),
                };
        return data;
    };



	this.getData = function() {
		return {};
	};

	this.init();
};
